import { useMatches } from '@tanstack/react-router';

/** The deepest matched route's `staticData.title` (routes declare one each). */
export function usePageTitle(): string {
  const matches = useMatches();
  for (let i = matches.length - 1; i >= 0; i -= 1) {
    const title = matches[i]?.staticData.title;
    if (title) return title;
  }
  return 'Lemon AI';
}
